<script>
  import OrderTable from "../../../views/generic/OrderTable/OrderTable.svelte";
  import AuthenticationRequired from "../../../components/functional/AuthenticationRequired.svelte";
  import ProjectPageBase from "../../../components/pages/projects/[project]/ProjectPageBase.svelte";
  import FetchOrderTableData from "../../../views/generic/OrderTable/FetchOrderTableData.svelte";

  let styleIndex
</script>

<AuthenticationRequired>
  <ProjectPageBase let:projectId let:user>
    <FetchOrderTableData
      projectId={projectId}
      refetchInterval={10000}
      styleIndex={styleIndex}
      let:styles
      let:ordersData
    >
      <OrderTable
        user={user}
        projectId={projectId}
        styles={styles}
        ordersData={ordersData}
        bind:styleIndex={styleIndex}
      />
    </FetchOrderTableData>
  </ProjectPageBase>
</AuthenticationRequired>
